<template>
  <svg
    id="approved"
    xmlns="http://www.w3.org/2000/svg"
    width="36.343"
    height="36.358"
    viewBox="0 0 36.343 36.358"
  >
    <path
      id="Path_1550"
      data-name="Path 1550"
      d="M20.839,11a9.839,9.839,0,1,0,9.839,9.839A9.85,9.85,0,0,0,20.839,11ZM25.1,18.933l-4.919,5.676a1.136,1.136,0,0,1-.817.391h-.041a1.13,1.13,0,0,1-.8-.333l-2.649-2.649a1.136,1.136,0,0,1,1.606-1.606L19.268,22.2l4.12-4.754A1.136,1.136,0,1,1,25.1,18.933Z"
      transform="translate(5.666 5.681)"
      :fill="color"
    />
    <path
      id="Path_1551"
      data-name="Path 1551"
      d="M13.8,0,6.446.03a2.637,2.637,0,0,0-2.3,1.362L.3,8.355l12.76-.03Z"
      transform="translate(0.169 0.03)"
      :fill="color"
    />
    <path
      id="Path_1552"
      data-name="Path 1552"
      d="M24.282,8.305l-3.89-6.963A2.661,2.661,0,0,0,18.076-.02L10.72.01l.772,8.325Z"
      transform="translate(5.522 0.02)"
      :fill="color"
    />
    <path
      id="Path_1553"
      data-name="Path 1553"
      d="M30.279,10.6a12.892,12.892,0,0,0-16.65,12.306,12.619,12.619,0,0,0,.575,3.8l-11.761.03H2.427A2.394,2.394,0,0,1,.051,24.347L-.01,7.046l14-.03h2.271l14-.045Z"
      transform="translate(0.01 3.611)"
      :fill="color"
    />
  </svg>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Shipment_Icon",
  props: {
    color: {
      default: "#1C274C",
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
  },
};
</script>
